import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllPersonActivitiesUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllPersonActivities
  implements GetAllPersonActivitiesUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllPersonActivitiesUseCaseInterface.Params,
  ): Promise<GetAllPersonActivitiesUseCaseInterface.Result> {
    const { id, ...restParams } = params;

    const requestUrl = `${this.url}/${id}`;

    const httpResponse = await this.httpClient.request({
      url: generateUrl(requestUrl, restParams),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
